import { render, staticRenderFns } from "./OfferSalesTableHeaders.vue?vue&type=template&id=48b34836&scoped=true"
import script from "./OfferSalesTableHeaders.vue?vue&type=script&lang=js"
export * from "./OfferSalesTableHeaders.vue?vue&type=script&lang=js"
import style0 from "./OfferSalesTableHeaders.vue?vue&type=style&index=0&id=48b34836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b34836",
  null
  
)

export default component.exports